import styled from "styled-components";
import { FaTimes } from "react-icons/fa";
import { Link as LinkR } from 'react-router-dom'
import { Link as LinkS } from 'react-scroll'

export const SidebarContainer = styled.aside`
    position: fixed;
    z-index: 999;
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme.colors.backgroundSecondary};
    display: grid;
    align-items: center;
    top: 0;
    left: 0;
    transition: 0.3s all ease-in-out;
    opacity: ${({ $isOpen }) => ($isOpen ? '100%' : '0')};
    top: ${({ $isOpen }) => ($isOpen ? '0' : '-100%')};

`

export const CloseIcon = styled(FaTimes)`
    color: ${({ theme }) => theme.colors.white};

`

export const Icon = styled.div`
    position: absolute;
    top: 1.2rem;
    right: 1.5rem;
    background: transparent;
    font-size: 2rem;
    cursor: pointer;
    outline: none;

`
export const SidebarWrapper = styled.div`
    color: ${({ theme }) => theme.colors.white};

`

export const SidebarMenu = styled.ul`
    padding: 0;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(6, 80px);
    text-align: center;

    @media screen and (max-width: 480px) {
        grid-template-rows: repeat(6, 60px);
    }

`

export const SidebarLink = styled(LinkS)`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.4rem;
    text-decoration: none;
    list-style: none;
    transition: 0.2s all ease-in-out;
    color: ${({ theme }) => theme.colors.white};
    cursor: pointer;

    &:hover {
        color: ${({ theme }) => theme.colors.primary};
        transition: 0.2s all ease-in-out;
    }

`

export const SideBtnWrap = styled.div`
    display: flex;
    justify-content: center;

`

export const SidebarRoute = styled.button`
    border-radius: 50px;
    background: ${({ theme }) => theme.colors.primary};
    white-space: nowrap;
    padding: 15px 35px;
    color: ${({ theme }) => theme.colors.white};
    font-size: 1.2rem;
    outline: none;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    font-weight: 900;

    &:hover {
        transition: all 0.2s ease-in-out;
        background: ${({ theme }) => theme.colors.white};
        color: ${({ theme }) => theme.colors.primary};
    }

`